import React from "react";
import { Controller } from "react-hook-form";
import { Radio, FormControlLabel, RadioGroup } from "@mui/material";

const RadioField = ({ name, label, control, options, rules, renderRelatedFields }) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px" }}>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field, fieldState: { error } }) => (
                    <>
                        <label style={{ display: "flex", alignItems: "center" }}>
                            {label}
                            {rules?.required && <span style={{ color: "red" }}> *</span>}
                            {error && (
                                <span style={{ color: "red", fontSize: "12px", marginLeft: "8px" }}>
                                    {error.message || "This field is required"}
                                </span>
                            )}
                        </label>
                        <RadioGroup {...field} style={{ display: "flex", flexDirection: "column" }}>
                            {options.map((option) => (
                                <div
                                    key={option.value}
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap", // Ensures wrapping on small screens
                                        alignItems: "center",
                                        gap: "8px", // Adds spacing between elements
                                        marginBottom: "8px",
                                    }}
                                >
                                    <FormControlLabel
                                        value={option.value}
                                        control={<Radio />}
                                        label={option.label}
                                        style={{ flex: "0 0 auto" }} // Prevents label from stretching
                                    />
                                    {field.value === option.value && (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexWrap: "wrap", // Ensures related fields wrap
                                                gap: "8px", // Spacing between related fields
                                                flex: "1 1 auto", // Allows related fields to take available space
                                            }}
                                        >
                                            {renderRelatedFields?.(option)}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </RadioGroup>
                    </>
                )}
            />
        </div>
    );
};

export default RadioField;
